import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { observer } from "mobx-react";
import MetaTags from "react-meta-tags";
import { withTranslation } from "react-i18next";
import contentStorage from "../storages/contentStorage";
import Page from "../layouts/Page";
import ContentPageTitle from "./ContentPageParts/ContentPageTitle";
import ContentPageImage from "./ContentPageParts/ContentPageImage";
import ContentPageTagsBlock from "./ContentPageParts/ContentPageTagsBlock";
import ContentPagePostsBlock from "./ContentPageParts/ContentPagePostsBlock";
import currentUserStorage from "../storages/currentUserStorage";
import Loader from "../UI/atoms/loaders/Loader";
import BreadcrumbsBlock from "../UI/molecules/breadcrumbs/BreadcrumbsBlock";
import EditableText from "../UI/organisms/EditableText/EditableText";
import Core from "../core/Core";
import currentCategoryStorage from "../storages/currentCategoryStorage";

class ContentPage extends Component {
  render() {
    const { t } = this.props;
    const { slug } = this.props.match.params;
    // console.log("PROCESS ROUTE", contentStorage.pages);
    if (
      !contentStorage.pages ||
      !contentStorage.pages[`${slug}_${currentUserStorage.language}`]
    ) {
      return (
        <Page
          id="content"
          loadingConfig={
            {
              // initial: true,
            }
          }
        >
          <Loader>
            {/* <div>{`${slug}_${currentUserStorage.language}`}</div> */}
          </Loader>
        </Page>
      );
    }
    const {
      content,
      title,
      short,
      pubDate,
      author,
      mainImage,
      tags,
      prevPost,
      nextPost,
      altText,
    } = contentStorage.pages[`${slug}_${currentUserStorage.language}`].content;
    const { changeText, saveContent } =
      contentStorage.pages[`${slug}_${currentUserStorage.language}`];
    // document.getElementsByTagName("title").item(0).innerText = title;
    return (
      <Page
        id="content"
        loadingConfig={{
          initial: true,
        }}
      >
        <MetaTags>
          <title>{title} в интернет-магазине детской одежды ALFAKID</title>
        </MetaTags>
        <BreadcrumbsBlock
          homeTitle={t("HOME")}
          homeLink={Core.routing.predefinedRoutes.home}
          items={[]}
          delimiter=">>"
          currentTitle={title}
        />
        <div className="article__container article container">
          <div className="article__body article__body--max-width col">
            <div
              data-section-id="article-body"
              data-section-type="article-body"
            >
              <article className="article-body mt-30">
                <div className="mb-25 text-center">
                  <ContentPageTitle title={title} />
                  {/* <ContentPagePublicationInfo */}
                  {/*  pubDate={pubDate} */}
                  {/*  author={author} */}
                  {/* /> */}
                </div>

                {mainImage && (
                  <ContentPageImage src={mainImage} altText={altText} />
                )}
                <div
                  className="container"
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                />
                {/* <EditableText */}
                {/*  text={content} */}
                {/*  path={`content.${slug}`} */}
                {/*  handleChange={(text) => changeText(text)} */}
                {/*  handleSave={saveContent} */}
                {/*  editable={currentUserStorage.isAdmin} */}
                {/* /> */}
                {/* <div */}
                {/*  className="rte" */}
                {/*  dangerouslySetInnerHTML={{ */}
                {/*    __html: content, */}
                {/*  }} */}
                {/* /> */}
                <div className="clearfix" />
                <div className="mt-35">
                  {tags && <ContentPageTagsBlock tags={tags} />}
                </div>
                <div className="article__nav py-55 mt-40 border-top">
                  <div className="d-flex">
                    <div className="d-flex flex-column w-100">
                      {/* <h4 className="h5 mb-10"> */}
                      {/*  <Link to="/blogs/blog/three-of-the-best-red-lipsticks-for-spring"> */}
                      {/*    {t( */}
                      {/*      "Three of the best red lipsticks for spring" */}
                      {/*    )} */}
                      {/*  </Link> */}
                      {/* </h4> */}
                      <ContentPagePostsBlock
                        prevPost={prevPost}
                        nextPost={nextPost}
                      />
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </Page>
    );
  }
}

ContentPage.propTypes = {};

export default withTranslation()(withRouter(observer(ContentPage)));
